import api from '../lib/api';
import type { PagedResponse } from '../types/paging';

export interface SubmitAppSuggestionRequest {
  name: string;
  reason: string;
  url: string;
}

export interface AppSuggestionResponse {
  id: string;
  tenantId: string;
  userId: string;
  name: string;
  reason: string;
  url: string;
  /** 0=pending 1=reviewed 2=accepted 3=declined */
  status: number;
  createdAt: string;
}

/** GET /api/v1/app-catalog/roadmap — single roadmap item wire shape. */
export interface AppCatalogRoadmapItemResponse {
  id: string;
  code: string;
  name: string;
  expectedQuarter: string;
  description: string;
  createdAt: string;
  updatedAt: string | null;
}

/** App catalog API servisi — uygulama oneri + roadmap akisi. */
export const appCatalogApi = {
  /**
   * Uygulama onerisi gonder.
   * POST /api/v1/app-catalog/suggestions
   * TenantId ve UserId JWT'den turetilir; request body'de gonderilmez.
   */
  submitSuggestion: (body: SubmitAppSuggestionRequest): Promise<AppSuggestionResponse> =>
    api
      .post<AppSuggestionResponse>('/api/v1/app-catalog/suggestions', body)
      .then((r) => r.data),

  /**
   * Yakininda gelen entegrasyonlarin yol haritasini cek.
   * GET /api/v1/app-catalog/roadmap
   * TenantAccess — herhangi bir tenant uyesi okuyabilir.
   */
  getRoadmap: (
    page = 1,
    pageSize = 100,
    signal?: AbortSignal,
  ): Promise<PagedResponse<AppCatalogRoadmapItemResponse>> =>
    api
      .get<PagedResponse<AppCatalogRoadmapItemResponse>>('/api/v1/app-catalog/roadmap', {
        params: { page, pageSize },
        signal,
      })
      .then((r) => r.data),
};
